var map = {
	"./0.jpg": 764,
	"./1.jpg": 489,
	"./2.jpg": 998,
	"./3.jpg": 459,
	"./4.jpg": 976,
	"./5.jpg": 885,
	"./6.jpg": 898,
	"./7.jpg": 551,
	"./8.jpg": 900,
	"./9.jpg": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 557;